export default function bindAll(that) {
  Object.getOwnPropertyNames(that.constructor.prototype).forEach((funcName) => {
    if (['constructor'].includes(funcName)) return;
    that[funcName] = that[funcName].bind(that);
  });
}
